import { useMutation } from "react-query";
import { doc, updateDoc } from "firebase/firestore";
import { GameStatus } from "./Game";
import { useSelector } from "../../../redux/store";
import { firestore } from "../../../utils/firebase/setupFirebase";

export const usePrepareForNamesMutation = () => {
  const game = useSelector((state) => state.game.game);
  const gameRefUrl = useSelector((state) => state.game.gameRefUrl);
  const gameRef = doc(firestore, gameRefUrl!);

  return useMutation(async () => {
    const members = Object.values(game!.membersMap);

    const updateObject: Record<string, any> = {
      status: GameStatus.WAIT_FOR_INVENTED_NAME,
    };

    members.forEach((member, index) => {
      const nextUserIndex = (index + 1) % members.length;
      const nextUser = members[nextUserIndex];

      updateObject[`membersMap.${member.userId}.inventedUserId`] =
        nextUser.userId;
      updateObject[`membersMap.${member.userId}.inventedName`] = null;
      updateObject[`membersMap.${member.userId}.solved`] = false;
    });
    await updateDoc(gameRef, updateObject);
  });
};
